import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ActivityLogChangesetPayload, Changeset, formatAttribute, formatData, formatValue } from './common';
import { getTemplateUpdatedValue } from './templateRenderers';

const useGetActivityLogChangesetsQuery = (changesetIds?: string[]) => {
  const { data, isLoading } = useQuery(
    [API_URL.ACTIVITY_LOGS_MAP, changesetIds?.join()],
    // TODO: the type is missing
    () => api.get(`${API_URL.ACTIVITY_LOGS_MAP}?ids=${changesetIds?.join()}`),
    {
      enabled: Boolean(changesetIds?.length),
    }
  );

  const formattedData = useMemo(() => {
    if (!data?.data) return [];

    return Object.keys(data?.data)
      ?.map((changesetId) =>
        formatData(data?.data[changesetId] as ActivityLogChangesetPayload[])?.map(
          (item): Changeset => ({
            id: item?.id,
            changesetId,
            fieldName: item.fieldName,
            attribute: formatAttribute(item.fieldName),
            previous: formatValue(item.fieldName, item.oldValue),
            updated: formatValue(item.fieldName, item.newValue),
            updatedNode: getTemplateUpdatedValue(item),
          })
        )
      )
      ?.flat();
  }, [data]);

  return {
    formattedData,
    isLoading,
  };
};

export default useGetActivityLogChangesetsQuery;
